import React, { Component } from "react";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import League from "./League";
import PasswordDialog from "./PasswordDialog";
import EditResult from "./EditResult";
import Toast from "./Toast";

class App extends Component {
  render() {
    return (
      <MuiThemeProvider>
        <div style={styles.container}>
          <League division={1} color="red" />
          <League division={2} color="green" />
          <League division={3} color="blue" />
          <EditResult />
          <PasswordDialog />
          <Toast />
        </div>
      </MuiThemeProvider>
    );
  }
}

const styles = {
  container: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center"
  }
};

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js